import { Check } from 'lucide-react'

import { cn } from '~/utils/tailwind-utils'

// Marks the plan the org holds inside a plan toggle segment. The selected
// segment is dark (white in dark mode), so the badge inverts there to stay
// visible; on an unselected segment it reads as a green "unlocked" dot.
export const PlanCheckBadge = ({ isSelected }: { isSelected: boolean }) => (
  <span
    aria-hidden
    className={cn(
      'flex size-4 items-center justify-center rounded-full transition-colors duration-150',
      {
        'bg-white text-primary dark:bg-black': isSelected,
        'bg-green-500 text-white': !isSelected,
      },
    )}
  >
    <Check className="size-2.5" strokeWidth={3} />
  </span>
)
